/**
 * d16n::legacy
 * d16n::source:<POfferPriceType.vue>
 * d16n::helpers-file
 */

import type { PriceType } from '../../offer'
import { TEMPORARY_PRICE, PREORDER_PRICE } from '../../offer.business'
import { i18n } from '@b2ag/locale'

export const getPriceTypeMessage = (priceType: PriceType) => {
  switch (priceType) {
    case TEMPORARY_PRICE:
      return i18n._('Prix provisoire')
    case PREORDER_PRICE:
      return i18n._('Prix de réservation')
    default:
      return ''
  }
}

export const getPriceTypeTooltip = (priceType: PriceType) => {
  switch (priceType) {
    case PREORDER_PRICE:
      return i18n._(
        'Ce tarif est un coût de réservation, le prix final sera fixé ultérieurement avec déduction possible de ce coût.',
      )
    case TEMPORARY_PRICE:
      return i18n._('Le prix définitif sera fixé en fonction de la quantité réelle livrée.')
    default:
      return ''
  }
}
